import React from 'react';
import { useTranslation } from 'react-i18next';

import { WifiOff, RefreshCw } from 'lucide-react';
function NetworkErrorPage() {
  const { t } = useTranslation('errorpage');

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div data-testid="network-error-container" className="fixed inset-0 bg-gradient-to-br from-teal-50 via-cyan-50 to-emerald-50 flex items-center justify-center z-50 p-3 sm:p-4">
      <div data-testid="network-error-content" className="text-center w-full max-w-xs sm:max-w-sm md:max-w-md">
        {/* Animated WiFi Off Icon */}
        <div data-testid="network-error-icon-wrapper" className="relative mb-3 sm:mb-4">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-gradient-to-br from-teal-100 to-cyan-100 rounded-full animate-pulse"></div>
          </div>
          <div className="relative flex items-center justify-center">
            <WifiOff data-testid="network-error-icon" className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 text-teal-600 animate-bounce" />
          </div>
        </div>

        {/* Title */}
        <h1 data-testid="network-error-title" className="text-lg sm:text-xl md:text-2xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent mb-2">
          {t('errorpage.no_internet_title', 'No Internet')}
        </h1>

        {/* Message */}
        <p data-testid="network-error-message" className="text-sm sm:text-base text-gray-700 mb-3 font-medium">
          {t('errorpage.no_internet_message', 'Check your connection')}
        </p>

        {/* Suggestion */}
        <div data-testid="network-error-suggestions" className="bg-white/90 backdrop-blur-sm rounded-xl p-3 sm:p-4 mb-4 shadow-lg border border-teal-200">
          <ul className="text-left text-xs sm:text-sm text-gray-600 space-y-1">
            <li data-testid="network-error-step-1" className="flex items-start">
              <span className="inline-block w-1.5 h-1.5 bg-teal-500 rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
              <span>{t('errorpage.no_internet_step1', 'Check WiFi/mobile data')}</span>
            </li>
            <li data-testid="network-error-step-2" className="flex items-start">
              <span className="inline-block w-1.5 h-1.5 bg-teal-500 rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
              <span>{t('errorpage.no_internet_step2', 'Toggle airplane mode')}</span>
            </li>
            <li data-testid="network-error-step-3" className="flex items-start">
              <span className="inline-block w-1.5 h-1.5 bg-teal-500 rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
              <span>{t('errorpage.no_internet_step3', 'Restart router')}</span>
            </li>
          </ul>
        </div>

        {/* Retry Button */}
        <button
          data-testid="network-error-retry-button"
          onClick={handleRetry}
          className="group inline-flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white font-medium rounded-lg shadow-md hover:shadow-lg text-xs sm:text-sm transition-all duration-200 hover:scale-105 active:scale-95 cursor-pointer"
        >
          <RefreshCw data-testid="network-error-retry-icon" className="w-3.5 h-3.5 sm:w-4 sm:h-4 group-hover:rotate-180 transition-transform duration-300" />
          {t('errorpage.retry_connection_button', 'Retry')}
        </button>
      </div>
    </div>
  );
}

export default NetworkErrorPage;
